import React, { useEffect } from 'react';
import { Flex, Text, Icon, Autocomplete, TextField } from '@scale/scaleui-radix';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { useFetchAllWorkerSkills } from 'react-scale/hooks/workerSkills/queries/useFetchAllWorkerSkills';

interface WorkerSkillsAutoCompleteProps {
  workerSkills: string[];
  onWorkerSkillsChange: (workerSkills: string[]) => void;
}

export const WorkerSkillsAutoComplete: React.FC<WorkerSkillsAutoCompleteProps> = ({
  workerSkills,
  onWorkerSkillsChange,
}) => {
  const { data: allSkills, refetch: refetchSkills } = useFetchAllWorkerSkills();

  useEffect(() => {
    if (!allSkills) {
      refetchSkills();
    }
  }, [allSkills, refetchSkills]);

  return (
    <Flex direction="column" gap="2">
      <Text size="2" weight="medium">
        What worker skills is this tag used for?
      </Text>
      <Autocomplete.Root
        multiple
        defaultValue={workerSkills}
        onValueChange={(newValue: string[]) => onWorkerSkillsChange(newValue)}
      >
        <Autocomplete.Content>
          <Autocomplete.TextField placeholder="Type to search for worker skills">
            <TextField.Slot side="left">
              <Icon icon={faSearch} label="Search" />
            </TextField.Slot>
            <Autocomplete.Values>
              {(allSkills ?? []).map(skill => (
                <Autocomplete.Value key={skill.id} value={skill.id}>
                  {skill.name}
                </Autocomplete.Value>
              ))}
            </Autocomplete.Values>
            <Autocomplete.Reset />
          </Autocomplete.TextField>
          <Autocomplete.Items>
            {(allSkills ?? []).map(skill => (
              <Autocomplete.Item key={skill.id} value={skill.id}>
                {skill.name}
              </Autocomplete.Item>
            ))}
          </Autocomplete.Items>
        </Autocomplete.Content>
      </Autocomplete.Root>
    </Flex>
  );
};
